const HOPPER_BRAND = "hopper";
const ATHOTEL_BRAND = "athotel";
const ATHOTEL_STAGING_HOST =
  "booking-ui-git-hopper-redirect-at-hotel.vercel.app";

export const currentBrand = (): string => {
  const nextPublicBrand = process.env["NEXT_PUBLIC_BRAND"];
  if (
    nextPublicBrand !== null &&
    nextPublicBrand !== undefined &&
    nextPublicBrand !== ""
  )
    return nextPublicBrand;
  const viteBrand = import.meta.env["VITE_BRAND"] as string | undefined;
  if (viteBrand !== null && viteBrand !== undefined && viteBrand !== "")
    return viteBrand;
  try {
    if (
      window.location.hostname.includes(ATHOTEL_BRAND) ||
      window.location.hostname.includes(ATHOTEL_STAGING_HOST)
    ) {
      return ATHOTEL_BRAND;
    }
    return HOPPER_BRAND;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (_e) {
    return HOPPER_BRAND;
  }
};

export const brandBffUrl = () => {
  return isAtHotelBrand()
    ? (process.env["ATHOTEL_WEB_BFF_URL"] ??
        "http://athotel.hopper-web-bff.svc.cluster.local:7070")
    : (process.env["HOPPER_WEB_BFF_URL"] ??
        "http://unit.hopper-web-bff.svc.cluster.local:7070");
};

const ATTRIBUTION_PARAM_KEY = "attribution";
const ATTRIBUTION_COOKIE_NAME = "Hopper-Attribution";

export function getBrandAttribution() {
  const params = new URLSearchParams(window.location.search);
  return params.get(ATTRIBUTION_PARAM_KEY);
}

export function detectBrandAttribution() {
  const attribution = getBrandAttribution();
  if (attribution !== null && attribution !== undefined && attribution !== "") {
    document.cookie = `${ATTRIBUTION_COOKIE_NAME}=${attribution}; path=/`;
  }
}

export const isAtHotelBrand = () => currentBrand() === ATHOTEL_BRAND;
export const isHopperBrand = () => currentBrand() === HOPPER_BRAND;
export const isBrandedSite = () => !isHopperBrand();

export const getAtHotelBrandButtonStyling = ({
  filled,
}: {
  filled: boolean;
}) =>
  isAtHotelBrand()
    ? { style: filled ? { background: "#17803C" } : { color: "#17803C" } }
    : {};
